// extracted by mini-css-extract-plugin
export default {"ganttVerticalContainer":"TaskGantt_ganttVerticalContainer__YFf32","horizontalContainer":"TaskGantt_horizontalContainer__ghnyC"};